// extracted by mini-css-extract-plugin
module.exports = {"AppContent":"AppContent_qqMfb","AppContentContainer":"AppContentContainer_xul4d"};